// Synchronisation panier REVDECO — les lignes « Personnalisation » suivent la commande.
// Chargé sur tout le site (stylesheets.liquid), actif seulement sur la page panier :
//   - quantité produit modifiée → la ligne perso s'aligne (quantité ET palier de prix) ;
//   - produit retiré → sa perso part avec lui ;
//   - ligne perso supprimée à la main → bandeau d'alerte + bouton « Rétablir » ;
//   - code remise volume recalé sur la vraie quantité de produits (perso exclue).
(function () {
  if (!/^\/cart\/?$/.test(location.pathname)) return;
  var MINS = [1, 10, 30, 60, 120, 250];
  var CODES = [null, 'REVDECO10', 'REVDECO30', 'REVDECO60', 'REVDECO120', 'REVDECO250'];
  var tix = function (q) { var ix = 0; for (var i = 0; i < MINS.length; i++) { if (q >= MINS[i]) ix = i; } return ix; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var busy = false;

  function reconcile() {
    var PERSO = window.REVDECO_PERSO;
    if (!PERSO || busy) return;
    busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var prods = [], perso = [];
      (cart.items || []).forEach(function (it) { (it.handle === PERSO.handle ? perso : prods).push(it); });
      var qtyOf = {};
      prods.forEach(function (it) { qtyOf[it.handle] = (qtyOf[it.handle] || 0) + it.quantity; });

      var ops = [];
      perso.forEach(function (l) {
        var pour = (l.properties || {})._rd_pour, zone = (l.properties || {})._rd_zone;
        // mise en place broderie : une seule par emplacement, quelle que soit la quantité
        if (pour && (l.properties || {})._rd_setup) {
          if (!(qtyOf[pour] > 0)) ops.push({ key: l.key, quantity: 0 });
          else if (l.quantity !== 1) ops.push({ key: l.key, quantity: 1 });
          return;
        }
        if (!pour || !zone) return;
        var q = qtyOf[pour] || 0;
        if (q < 1) { ops.push({ key: l.key, quantity: 0 }); return; }
        var ent = (PERSO.byZone[zone] || [])[tix(q)];
        if (!ent) return;
        if (l.variant_id !== ent.id) {
          // le palier a changé → nouvelle variante au bon tarif, l'ancienne saute
          ops.push({ add: { id: ent.id, quantity: q, properties: l.properties } });
          ops.push({ key: l.key, quantity: 0 });
        } else if (l.quantity !== q) {
          ops.push({ key: l.key, quantity: q });
        }
      });

      // produits marqués personnalisés (_rd_zones) dont la ligne perso a disparu
      var covered = {};
      perso.forEach(function (l) { var p = (l.properties || {})._rd_pour; if (p) covered[p] = 1; });
      var orphans = [], seen = {};
      prods.forEach(function (it) {
        var z = (it.properties || {})._rd_zones;
        if (z && !covered[it.handle] && !seen[it.handle]) {
          seen[it.handle] = 1;
          orphans.push({ handle: it.handle, title: it.product_title, zones: z });
        }
      });
      renderBanner(orphans, qtyOf, PERSO);

      // code remise adapté à la quantité RÉELLE de produits.
      // ⚠️ remises limitées à une collection → l'application est au niveau des LIGNES
      // (item.discounts), cart_level_discount_applications reste vide.
      var realCount = 0;
      prods.forEach(function (it) { realCount += it.quantity; });
      var code = realCount > 0 ? CODES[tix(realCount)] : null;
      var applied = (cart.cart_level_discount_applications || []).map(function (d) { return d.title; });
      (cart.items || []).forEach(function (it) {
        (it.discounts || []).forEach(function (d) { if (applied.indexOf(d.title) === -1) applied.push(d.title); });
      });
      var needCode = !!(code && applied.indexOf(code) === -1);
      // garde-fou : jamais plus de 3 rechargements automatiques d'affilée
      var reloads = 0;
      try { reloads = +(sessionStorage.getItem('rd-sync-reloads') || 0); } catch (e) { }
      if (reloads >= 3) needCode = false;

      var chain = Promise.resolve();
      ops.forEach(function (op) {
        chain = chain.then(function () {
          if (op.add) {
            return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [op.add] }) });
          }
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: op.key, quantity: op.quantity }) });
        });
      });
      if (needCode) chain = chain.then(function () { return fetch('/discount/' + code, { credentials: 'same-origin' }); });
      chain.then(function () {
        busy = false;
        if (ops.length || needCode) {
          try { sessionStorage.setItem('rd-sync-reloads', String(reloads + 1)); } catch (e) { }
          location.reload();
        } else {
          try { sessionStorage.removeItem('rd-sync-reloads'); } catch (e) { }
        }
      }).catch(function () { busy = false; });
    }).catch(function () { busy = false; });
  }

  function renderBanner(orphans, qtyOf, PERSO) {
    var old = document.getElementById('rdCartWarn');
    if (old) old.remove();
    if (!orphans.length) return;
    var box = document.createElement('div');
    box.id = 'rdCartWarn';
    box.className = 'rd-cart-warn';
    box.innerHTML = '<b>⚠ Personnalisation retirée</b>'
      + '<span>La ligne « Personnalisation » de ' + orphans.map(function (o) { return esc(o.title); }).join(', ')
      + ' a été supprimée : sans elle, vos produits seront livrés <b>vierges</b> (sans impression de votre visuel).</span>'
      + '<button type="button" class="rd-cart-warn__btn">Rétablir la personnalisation</button>';
    box.querySelector('button').addEventListener('click', function () {
      var items = [];
      orphans.forEach(function (o) {
        var zones = [];
        try { zones = JSON.parse(o.zones); } catch (e) { }
        var q = qtyOf[o.handle] || 1;
        zones.forEach(function (z) {
          var ent = (PERSO.byZone[z.zone] || [])[tix(q)];
          if (ent) items.push({ id: ent.id, quantity: q, properties: { 'Pour': o.title + ' — ' + z.label, '_rd_pour': o.handle, '_rd_zone': z.zone } });
          if (ent && /^bro_/.test(z.zone) && PERSO.broSetup) {
            items.push({ id: PERSO.broSetup.id, quantity: 1, properties: { 'Pour': o.title + ' — ' + z.label, '_rd_pour': o.handle, '_rd_setup': z.id } });
          }
        });
      });
      if (!items.length) return;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { location.reload(); });
    });
    var anchor = document.querySelector('main') || document.body;
    anchor.insertBefore(box, anchor.firstChild);
  }

  // toute mutation du panier (boutons +/−, suppression…) déclenche une réconciliation
  var origFetch = window.fetch;
  window.fetch = function (u) {
    var p = origFetch.apply(this, arguments);
    try {
      var url = typeof u === 'string' ? u : ((u && u.url) || '');
      if (/\/cart\/(change|update|add|clear)/.test(url) && !busy) {
        p.then(function () { setTimeout(reconcile, 400); });
      }
    } catch (e) { }
    return p;
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 500); });
  } else {
    setTimeout(reconcile, 500);
  }
})();
